import {Model} from '@vuex-orm/core'
import LtmHasRoomtypeHasRoomltmAt from '@models/helpers/LtmHasRoomtypeHasRoomltmAt'

export default class LtmAt extends Model {
  static entity = 'ltmsAt'

  static fields() {
    return {
      id: this.number(null),
      label: this.string(null).nullable(),
      ltmHasRoomtypeHasRoomltms: this.hasMany(LtmHasRoomtypeHasRoomltmAt, 'ltms_id')
    }
  }
}
